import CdeStatusItem from 'components/molecules/files/cde-status/CdeStatusItem'

export default CdeStatusItem
